import { DatePipe, NgClass, NgIf } from "@angular/common";
import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterLink } from "@angular/router";
import {
    KursanmeldungApiService,
    KursanmeldungVO, KursInfoVO,
    TeilnehmerApiService,
    TeilnehmerVO,
} from "@core/api/v1";
import { kursTitelMap } from "@core/model/kursTitel";
import { zertifizierungstyp } from "@core/model/optionen/zertifizierungstyp";
import { LoginService } from "@core/services/login/login.service";
import { NotificationService } from "@core/services/notification/notification.service";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";
import { InputTextModule } from "primeng/inputtext";
import { ListboxModule } from "primeng/listbox";
import ZertifizierungstypEnum = KursanmeldungVO.ZertifizierungstypEnum;
import TypEnum = KursInfoVO.TypEnum;

@Component({
  selector: 'app-widerruf',
  standalone: true,
    imports: [
        CheckboxModule,
        DropdownModule,
        InputMaskModule,
        InputTextModule,
        ListboxModule,
        NgIf,
        ReactiveFormsModule,
        CalendarModule,
        NgClass,
        DatePipe,
        FaIconComponent,
        RouterLink,
    ],
  templateUrl: './widerruf.component.html',
  styleUrl: './widerruf.component.scss'
})
export class WiderrufComponent implements OnInit {
    protected readonly zertifizierungsTypen = Object.entries(zertifizierungstyp).map(([key, label]) => ({
        label, value: key as ZertifizierungstypEnum
    }));

    lehrgaenge: KursanmeldungVO[] = [];
    ausgewaehlterLehrgang: KursanmeldungVO;
    teilnehmer: TeilnehmerVO;
    name: string;
    adresse: string;
    lehrgangsDatum: string;
    istEingeloggt: boolean;

    formular = this.formbuilder.group({
        lehrgang: [null, Validators.required],
        vertragsabschluss: [new Date(), Validators.required]
    });

    constructor(private formbuilder: FormBuilder,
                private api: KursanmeldungApiService,
                private teilnehmerApi: TeilnehmerApiService,
                private notificationService: NotificationService,
                private loginService: LoginService) {
        this.loginService.isLoggedIn.subscribe((data) => {
            this.istEingeloggt = data;
        });
    }

    ngOnInit(): void {
        if (this.istEingeloggt) {
            this.holeWiderrufbareKursTeilnehmerMitTeilnehmer();

            this.teilnehmerApi.holeTeilnehmer().subscribe(data => {
                this.teilnehmer = data;

                this.name = "";

                if (this.teilnehmer.vorgestellterTitel != undefined) {
                    this.name = this.teilnehmer.vorgestellterTitel + " ";
                }

                this.name = this.name + this.teilnehmer.vorname + " " + this.teilnehmer.nachname;

                if (this.teilnehmer.nachgestellterTitel != undefined) {
                    this.name = this.name + " " + this.teilnehmer.nachgestellterTitel;
                }

                this.adresse = this.teilnehmer.adresse + ", " + this.teilnehmer.postleitzahl + " " + this.teilnehmer.ort;
            });
        }
    }

    widerrufen() {
        this.ausgewaehlterLehrgang = this.formular.getRawValue().lehrgang!;
        this.api.widerrufe(this.ausgewaehlterLehrgang.id).subscribe(data => {
                this.holeWiderrufbareKursTeilnehmerMitTeilnehmer();
        });

        this.notificationService.showSuccess("Widerruf angefragt");
        this.formular.reset();
        this.lehrgangsDatum = "";
    }

    titel(typ: TypEnum) {
        return kursTitelMap[typ];
    }

    fuegeDatumEin() {
        this.ausgewaehlterLehrgang = this.formular.getRawValue().lehrgang!;
        this.lehrgangsDatum = this.ausgewaehlterLehrgang.kurs.datum!.toString();
    }

    holeWiderrufbareKursTeilnehmerMitTeilnehmer() {
        this.api.holeWiderrufbareKursTeilnehmerMitTeilnehmer().subscribe(data => {
            this.lehrgaenge = data;
        });
    }
}
